export enum ActivityModes {
  wins,
  engagement,
  myAuctions,
  logs,
  invoices,
  myPosts,
}

export enum FilterModes {
  auction,
  post,
  all,
}

export enum FilterModesDate {
  newest,
  oldest,
  all,
}

export enum AuctionFilter {
  upcoming,
  active,
  finished,
  none,
}

export enum AuctionPublic {
  Public,
  Private,
}

export enum HomeFilterMode {
  BuyNow,
  FirstWins,
  Auction,
  All,
}
